<mat-form-field>
  <input
    matInput
    #inputDireccion
    placeholder="Dirección"
    [(ngModel)]="direccion"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onChangeDir($event.option.value)"
  >
    @for (direccion of direcciones; track direccion) {
      <mat-option [value]="direccion">
        {{ direccion }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
